import { useOptionalWorkspace } from "../features/workspace/WorkspaceContext";

/**
 * FB2-40: props for `FeatureIntro` that link the panel's "Learn more" to the matching Help Center
 * guide (`/w/:workspaceId/help-center/<slug>`). Renders no link outside the workspace shell.
 */
export function useHelpLink(slug: string): { readonly helpHref?: string } {
  const workspace = useOptionalWorkspace()?.workspace;
  return workspace ? { helpHref: `/w/${workspace.id}/help-center/${slug}` } : {};
}
